import ToDoApp from "./Component/ToDoApp.js";

function App() {
  return (
    <ToDoApp />
  );
}

export default App;
